import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    group: ""
}

export const optionsSlice = createSlice({
    name: 'options',
    initialState,
    reducers: {
        setGroup: (state, action) => {
            state.group = action.payload;
        },
        removeGroup: (state) => {
            state.group = ""
        }
    },
})

export const { setGroup, removeGroup } = optionsSlice.actions

export default optionsSlice.reducer